import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export interface LbmEditModalOutput {
	projectName: string;
	projectDesc: string;
	projectMobile: boolean;
	projectId: number;
}

@Component({
	selector: 'app-lbm-edit-modal',
	templateUrl: './lbm-edit-modal.component.html',
	styleUrls: ['./lbm-edit-modal.component.css']
})
export class LbmEditModalComponent implements OnInit {

	projectName: string;
	projectDesc: string;
	projectMobile: boolean;
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<LbmEditModalComponent>
	) { }

	cancel() {
		this.dialogRef.close(null);
	}
	apply() {
		// Close modal
		const data: LbmEditModalOutput = {
			projectName: this.projectName,
			projectDesc: this.projectDesc,
			projectMobile: this.projectMobile,
			projectId: this.data.prj_id
		};
		this.dialogRef.close(data);
	}
	ngOnInit() {
		this.projectName = this.data.prj_name;
		this.projectDesc = this.data.prj_desc;
		this.projectMobile = this.data.prj_mobile;
	}

}



// WEBPACK FOOTER //
// ./src/app/components/portal/super-user/lbm-config/lbm-edit-modal/lbm-edit-modal.component.ts